import { useEffect } from 'react';

const SITE = 'Brasil Livre Business';
const DEFAULT_DESC = 'Rede nacional de empresas e empreendedores que valorizam a livre iniciativa. Protótipo de demonstração.';

function setMeta(attr, key, value) {
  if (!value) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', value);
}

/**
 * Define título, descrição e metadados de compartilhamento (Open Graph / Twitter) por página.
 * Observação: para pré-visualização em redes sociais, a versão de produção deve
 * renderizar estes metadados no servidor (SSR/edge), pois robôs não executam JS.
 */
export function useSeo({ title, description, image, type = 'website' } = {}) {
  useEffect(() => {
    const fullTitle = title ? `${title} · ${SITE}` : `${SITE} — Plataforma nacional de negócios`;
    const desc = description || DEFAULT_DESC;
    const url = window.location.href;
    const img = image || `${window.location.origin}/og-default.svg`;
    document.title = fullTitle;
    setMeta('name', 'description', desc);
    setMeta('property', 'og:title', fullTitle);
    setMeta('property', 'og:description', desc);
    setMeta('property', 'og:type', type);
    setMeta('property', 'og:url', url);
    setMeta('property', 'og:image', img);
    setMeta('property', 'og:site_name', SITE);
    setMeta('name', 'twitter:card', 'summary_large_image');
    setMeta('name', 'twitter:title', fullTitle);
    setMeta('name', 'twitter:description', desc);
  }, [title, description, image, type]);
}

export const shareLinks = (url, text) => {
  const u = encodeURIComponent(url);
  const t = encodeURIComponent(text);
  return {
    whatsapp: `https://wa.me/?text=${t}%20${u}`,
    x: `https://twitter.com/intent/tweet?text=${t}&url=${u}`,
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${u}`,
  };
};
